export default __webpack_public_path__ + "static/events-dark-43a7a6f3a5b861850fbdf00a696bd820.png";